import React from 'react';

import { observer } from 'mobx-react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import classes from './NgzCardExpiredInfo.module.scss';
import { angularizeWithProviders } from '../../providers';
import { useCardExpiredInfo } from './hooks/useCardExpiredInfo';

const NgzCardExpiredInfo = observer(() => {
  const { isShowCardExpiredInfo, daysToCardExpiration } = useCardExpiredInfo();

  if (!isShowCardExpiredInfo) {
    return null;
  }

  return (
    <div className={classes.waringMessage}>
      <WarningAmberRoundedIcon fontSize="medium" />
      <p>Your credit card will be expired in {daysToCardExpiration} days.</p>
      <a href="#!/entity-profile" className={classes.link}>
        <EditRoundedIcon fontSize="medium" />
        <span>Edit Card</span>
      </a>
    </div>
  );
});

angularizeWithProviders(NgzCardExpiredInfo, 'ngzCardExpiredInfo', {});

export { NgzCardExpiredInfo };
